'use strict';

var UnmatchedCompetitorFaresQuickFilterDirective = function UnmatchedCompetitorFaresQuickFilterDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'UnmatchedCompetitorFaresQuickFilterController',
    template: require('../templates/unmatched-competitor-fares-quick-filter.html'),
    scope: {
      updateCallBack: '=',
      filter: '='
    },
    link: function link(scope, element) {
      element.on('mousedown', function (e) {
        e.stopImmediatePropagation();
      });
    }
  };
};
module.exports = UnmatchedCompetitorFaresQuickFilterDirective;